import { useEffect } from "react";
import "./ShrimpCursor.css";

export default function ShrimpCursor() {
	useEffect(() => {
		// На мобилях / тач-устройствах ничего не делаем
		if (typeof window !== "undefined") {
			const isTouchDevice =
				"ontouchstart" in window ||
				navigator.maxTouchPoints > 0 ||
				navigator.msMaxTouchPoints > 0;

			if (isTouchDevice) {
				return; // выходим — не создаём кастомный курсор
			}
		}

		// Создаём вытянутый SVG трезубец в стиле Maserati
		const tridentCursor = document.createElement("div");
		tridentCursor.className = "trident-cursor";
		tridentCursor.innerHTML = `
      <svg width="24" height="48" viewBox="0 0 24 48" xmlns="http://www.w3.org/2000/svg">
        <g fill="#0c4a6e" stroke="#bae6fd" stroke-width="0.8">
          <!-- Центральный зубец (длинный) -->
          <path d="M 12 1 L 11.5 18 L 11.5 32 L 12.5 32 L 12.5 18 L 12 1 Z" />
          
          <!-- Левый зубец -->
          <path d="M 7 3 L 6 16 Q 6 20 9 24 L 10 24 Q 7 20 7 16 L 8 3 Z" />
          
          <!-- Правый зубец -->
          <path d="M 17 3 L 18 16 Q 18 20 15 24 L 14 24 Q 17 20 17 16 L 16 3 Z" />
          
          <!-- Рукоятка (внизу) -->
          <ellipse cx="12" cy="34" rx="2.5" ry="1.2" fill="#0c4a6e" stroke="#bae6fd" stroke-width="0.6"/>
          <rect x="11" y="32" width="2" height="12" rx="0.8" fill="#0c4a6e" stroke="#bae6fd" stroke-width="0.6"/>
          <ellipse cx="12" cy="44" rx="3" ry="1.8" fill="#0c4a6e" stroke="#bae6fd" stroke-width="0.6"/>
        </g>
      </svg>
    `;
		document.body.appendChild(tridentCursor);

		const handleMouseMove = (e) => {
			document.documentElement.style.setProperty(
				"--cursor-x",
				`${e.clientX}px`
			);
			document.documentElement.style.setProperty(
				"--cursor-y",
				`${e.clientY}px`
			);
		};

		document.addEventListener("mousemove", handleMouseMove);

		return () => {
			document.removeEventListener("mousemove", handleMouseMove);
			if (tridentCursor.parentNode) {
				tridentCursor.remove();
			}
		};
	}, []);

	return null;
}
